import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiDeletePrioShareDraft } from '../../../api';

interface DeletePrioShareDraftParams {
  prioShareId: string;
  projectExtensionId: string;
}

export function useDeletePrioShareDraft() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeletePrioShareDraftParams) => {
      return apiDeletePrioShareDraft(
        params.projectExtensionId,
        params.prioShareId
      );
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['prioShares', variables.projectExtensionId],
      });
    },
  });
}
